'use strict';

angular.module('app')
	.controller('RecentlyViewedCtrl', function($scope, $location, typeURL, Wishlist, RecentlyViewed, Search, utils) {
		var vm = this;

		vm.current = typeURL;
		vm.limit = 3;
		vm.search = Search;
		vm.goToShop = goToShop;

		RecentlyViewed.get().then(function(data) {
			vm.list = data;
		})

		vm.triggerWishlist = function(e, result, parent) {
			e.stopPropagation();
			e.preventDefault();
			var data = {
					item_type: result.model,
					item_slug: result.slug
				},
				type = 'add';

			if (result.isWishlist) {
				data = result.isWishlist;
				type = 'delete';
			}

			Wishlist[type](data).then(function(data) {
				if (type == 'add') {
					parent.isWishlist = data.item.id;
					result.isWishlist = data.item.id;
				} else {
					parent.isWishlist = false;
				}
			});
		}

		function goToShop(shop){
			var page = "";
			if (shop.kind === 10) {
				page = "la_page"
			}else if (shop.kind === 20){
				page = "dr_page"
			}else {
				return;
			}

			$location.path(utils.createURL(page, { location: shop.countrySlug, slug: shop.slug } ));
		}
	})